export const getEmojiForAmount = (amount: number, emoji: string): string => {
  if (amount > 150) return '🤠'
  if (amount > 75) return '🤑'
  return emoji
}
